import React, { useState, useEffect } from 'react';
import {
  AiOutlinePlayCircle,
  AiOutlineDownload,
  AiOutlineThunderbolt,
} from 'react-icons/ai';
import { useNavigate } from 'react-router-dom';
import './HeroSections.css';

const HeroSection3 = () => {
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState(0);

  const features = [
    { icon: '💻', text: 'React & .NET', color: '#3b82f6' },
    { icon: '🎨', text: 'Modern UI', color: '#10b981' },
    { icon: '📱', text: 'Responsive', color: '#60a5fa' },
    { icon: '⚡', text: 'Fast Setup', color: '#14b8a6' },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex(prev => (prev + 1) % features.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="hero-section-3">
      <div className="hero-3-grid-bg">
        {[...Array(100)].map((_, i) => (
          <div key={i} className="hero-3-grid-item" />
        ))}
      </div>

      <div className="hero-3-content-wrapper">
        <div className="row g-48 items-center hero-3-row">
          <div className="col col-24 lg-14 hero-3-left">
            <div className="hero-3-label" data-aos="fade-down">
              <AiOutlineThunderbolt /> Premium Quality Projects
            </div>

            <h1 className="hero-3-main-title" data-aos="fade-up">
              Build Your Dream
              <br />
              <span className="hero-3-gradient-text">Project Today</span>
            </h1>

            <span
              className="hero-3-main-description"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              Access 500+ premium software projects with complete source code,
              documentation, and video tutorials. Perfect for students,
              developers, and businesses.
            </span>

            <div
              className="hero-3-feature-tags"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              {features.map((feature, index) => (
                <div
                  key={index}
                  className={`hero-3-feature-tag ${index === activeIndex ? 'active' : ''}`}
                  style={{ '--tag-color': feature.color }}
                >
                  <span className="hero-3-tag-icon">{feature.icon}</span>
                  <span>{feature.text}</span>
                </div>
              ))}
            </div>

            <div
              className="hero-3-action-buttons"
              data-aos="fade-up"
              data-aos-delay="300"
            >
              <button
                type="button"
                className="btn btn-primary btn-lg hero-3-btn-primary"
                onClick={() => navigate('/products')}
              >
                <AiOutlineDownload /> Get Started Free
              </button>
              <button
                type="button"
                className="btn btn-lg hero-3-btn-play"
                onClick={() => navigate('/videos')}
              >
                <AiOutlinePlayCircle /> Watch Demo
              </button>
            </div>

            <div
              className="hero-3-trust-badges"
              data-aos="fade-up"
              data-aos-delay="400"
            >
              <div className="hero-3-badge">
                <span className="hero-3-badge-number">10K+</span>
                <span className="hero-3-badge-text">Students</span>
              </div>
              <div className="hero-3-divider" />
              <div className="hero-3-badge">
                <span className="hero-3-badge-number">500+</span>
                <span className="hero-3-badge-text">Projects</span>
              </div>
              <div className="hero-3-divider" />
              <div className="hero-3-badge">
                <span className="hero-3-badge-number">4.8★</span>
                <span className="hero-3-badge-text">Rating</span>
              </div>
            </div>
          </div>

          <div className="col col-24 lg-10 hero-3-right">
            <div
              className="hero-3-cards-container"
              data-aos="fade-left"
              data-aos-delay="200"
            >
              <div className="card hero-3-project-card hero-3-card-1">
                <div className="card-body">
                  <div className="hero-3-card-header">
                    <div className="hero-3-card-icon">🛒</div>
                    <div className="hero-3-card-status">
                      <span className="hero-3-status-dot"></span>
                      Trending
                    </div>
                  </div>
                  <div className="hero-3-card-title">E-Commerce Platform</div>
                  <div className="hero-3-card-tech">
                    <span>React</span>
                    <span>.NET</span>
                    <span>SQL</span>
                  </div>
                  <div className="hero-3-card-stats">
                    <span>⭐ 4.9</span>
                    <span>👥 2.5K</span>
                  </div>
                </div>
              </div>

              <div className="card hero-3-project-card hero-3-card-2">
                <div className="card-body">
                  <div className="hero-3-card-header">
                    <div className="hero-3-card-icon">🏥</div>
                    <div className="hero-3-card-status">
                      <span className="hero-3-status-dot"></span>
                      Popular
                    </div>
                  </div>
                  <div className="hero-3-card-title">Hospital Management</div>
                  <div className="hero-3-card-tech">
                    <span>React</span>
                    <span>Node</span>
                    <span>MongoDB</span>
                  </div>
                  <div className="hero-3-card-stats">
                    <span>⭐ 4.8</span>
                    <span>👥 1.8K</span>
                  </div>
                </div>
              </div>

              <div className="card hero-3-project-card hero-3-card-3">
                <div className="card-body">
                  <div className="hero-3-card-header">
                    <div className="hero-3-card-icon">📚</div>
                    <div className="hero-3-card-status">
                      <span className="hero-3-status-dot"></span>
                      New
                    </div>
                  </div>
                  <div className="hero-3-card-title">Learning Platform</div>
                  <div className="hero-3-card-tech">
                    <span>React</span>
                    <span>Firebase</span>
                  </div>
                  <div className="hero-3-card-stats">
                    <span>⭐ 4.7</span>
                    <span>👥 1.2K</span>
                  </div>
                </div>
              </div>

              <div className="hero-3-floating-element hero-3-float-1">
                <div className="hero-3-pulse-dot"></div>
                Live Projects
              </div>
              <div className="hero-3-floating-element hero-3-float-2">
                ⚡ Quick Setup
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection3;
